import { APP_BOOTSTRAP_LISTENER, ComponentRef, Provider } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { UserService } from "src/app/core/service/user.service";

export const USER_COMPLETE_REGISTRATION_PROVIDER: Provider = {
    provide: APP_BOOTSTRAP_LISTENER,
    multi: true,
    useFactory: verifUserPendingIssues,
    deps: [UserService, Router]
};

export function verifUserPendingIssues(userService: UserService, $router: Router) {
    return async (c: ComponentRef<any>) => {
        $router.events.subscribe((event) => {
            if (
                event instanceof NavigationEnd &&
                !$router.url.includes("complete-registration") &&
                !$router.url.includes("change-password")
            ) {
                userService.verifUserPendingIssues();
            }
        });
    };
}
